export const APP_NAME = 'Anzu（あんず）'